import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { paymentStatusOptions } from './constants'

const PaymentStatusSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      value={value}
      handleChange={e => onChange(e.target.value)}
      label={t('Estado de pago')}
      menuItems={paymentStatusOptions.map(o => ({ label: t(o.label), value: o.value }))}
    />
  )
}

export default PaymentStatusSelector
